import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Row, Col, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import renderSelectField from 'src/shared/components/form/Select';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import DatePickerOnly from 'src/shared/components/form/DatePickerOnly';
import BusinessIcon from '@mui/icons-material/Business';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import SaveIcon from '@mui/icons-material/Save';
import BadgeIcon from '@mui/icons-material/Badge';
import PublicIcon from '@mui/icons-material/Public';
import CategoryIcon from '@mui/icons-material/Category';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ScaleIcon from '@mui/icons-material/Scale';

const required = value => value ? undefined : 'Required';

// Compact Input Field Renderer
const renderCompactField = ({ input, placeholder, type, meta: { touched, error, warning }, disabled, icon: Icon }) => (
    <div>
        <div className={`input-group input-group-sm ${touched && error ? 'has-validation' : ''}`}>
            {Icon && (
                <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
                    <Icon style={{ fontSize: '1rem' }} />
                </span>
            )}
            <input
                {...input}
                className={`form-control form-control-sm ${touched && error ? 'is-invalid' : ''} ${Icon ? 'border-start-0' : ''}`}
                placeholder={placeholder}
                type={type}
                disabled={disabled}
                style={{ fontSize: '0.85rem' }}
            />
            {touched && ((error && <div className="invalid-feedback">{error}</div>) || (warning && <div className="text-warning small">{warning}</div>))}
        </div>
    </div>
);

const VehicleAddOrUpdate = ({ handleSubmit, status, vehicleData, setExpDate, vehicleRegistrationExpiryDate }) => {
    useEffect(() => {
        fetchVehicleDefaultData();
    }, []);

    const [isVehicleMakersList, setVehicleMakersList] = useState(null);
    const [isVehicleModelList, setVehicleModelList] = useState([]);
    const [isVehicleTypeList, setVehicleTypeList] = useState(null);
    const [isActiveHubList, setActiveHubList] = useState(null);

    let vehicleModelList = [];
    const filterAssetModel = async (event) => {
        if (isVehicleModelList) {
            if (event.value) {
                const response1 = await PndRestApi.GetVehicleModal(event.value).catch(error => {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: ${response1?.data?.status}`,
                        `Message: ${response1?.data?.message}`,
                    );
                })

                if (response1 && response1.status === 200 && response1.data.status === 200) {
                    if (response1.data.data && response1.data.data) {
                        response1.data.data.map(item => {
                            vehicleModelList.push({ "label": item.modelName, "value": item.vehicleModelId });
                        })
                        setVehicleModelList(vehicleModelList);
                    } else {
                        showNotification(
                            "theme-light",
                            "ltr",
                            `SuccessCode: ${response1?.data?.status}`,
                            `Message: Vehicle Model is not found`,
                        );
                    }
                }
            }
        }
    };


    const fetchVehicleDefaultData = async () => {
        let vehicleMakersList = [];
        let vehicleTypeList = [];
        let activeHub = [];
        try {

            const response1 = await PndRestApi.GetAllActiveHub(localStorage.getItem("ci")).catch(error => {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response1?.data?.status}`,
                    `Message: ${response1?.data?.message}`,
                );
            })

            if (response1 && response1.status === 200 && response1.data.status === 200) {
                if (response1.data.data.length > 0) {
                    response1.data.data.map(item => {
                        activeHub.push({ "label": item.hubName, "value": item.hubId });
                    })
                    setActiveHubList(activeHub);

                } else {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: ${response1?.data?.status}`,
                        `Message: Please create a Hub first`,
                    );
                }
            }

            const response = await PndRestApi.GetAllDefaultVehicleDetails();
            if (response.status === 200 && response.data.status === 200) {
                if (response.data.data && response.data.data.vehicleMakers) {
                    response.data.data.vehicleMakers.map(item => {
                        vehicleMakersList.push({ "label": item.makerName, "value": item.vehicleMakerId });
                    })
                    setVehicleMakersList(vehicleMakersList);
                }

                if (response.data.data && response.data.data.vehicleType) {
                    response.data.data.vehicleType.map(item => {
                        vehicleTypeList.push({ "label": item.name, "value": item.vehicleTypeId });
                    })
                    setVehicleTypeList(vehicleTypeList);
                }

            } else {
                console.error('Unexpected response status:', response.status);

            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const years = [];
    const startYear = 1990;
    const endYear = new Date().getFullYear();

    for (let year = endYear; year >= startYear; year--) {
        years.push({ "label": year.toString(), "value": year });
    }

    return (
        <form onSubmit={handleSubmit} className="p-2 bg-light">

            {/* Hub & Location Section */}
            <Card className="border-0 shadow-sm mb-2">
                <CardBody className="p-2">
                    <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                        <PublicIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Hub & Location</h6>
                    </div>
                    <Row className="g-2">
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Hub <span className='text-danger'>*</span></label>
                                <Field
                                    validate={required}
                                    name="hubInfo"
                                    component={renderSelectField}
                                    options={isActiveHubList}
                                    placeholder="Select Hub"
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Country <span className='text-danger'>*</span></label>
                                <Field
                                    validate={[required]}
                                    name="countryInfo"
                                    component={renderSelectField}
                                    options={[{ value: 1, label: "UAE" }]}
                                    placeholder="Select Country"
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>State/Emirates <span className='text-danger'>*</span></label>
                                <Field
                                    validate={[required]}
                                    name="stateInfo"
                                    component={renderSelectField}
                                    placeholder="Select State"
                                    options={[
                                        { value: 4, label: "Abu Dhabi" },
                                        { value: 8, label: "Ajman" },
                                        { value: 3, label: "Dubai" },
                                        { value: 1, label: "Fujairah" },
                                        { value: 2, label: "Ras Al Khaimah" },
                                        { value: 5, label: "Sharjah" },
                                        { value: 6, label: "Umm Al Quwain" },
                                    ]}
                                />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Vehicle Specs Section */}
            <Card className="border-0 shadow-sm mb-2">
                <CardBody className="p-2">
                    <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                        <DriveEtaIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Vehicle Specification</h6>
                    </div>
                    <Row className="g-2">
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Make <span className='text-danger'>*</span></label>
                                <Field
                                    validate={[required]}
                                    name="vehicleMakersInfo"
                                    component={renderSelectField}
                                    options={isVehicleMakersList}
                                    placeholder="Select Maker"
                                    onChange={event => filterAssetModel(event)}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Model <span className='text-danger'>*</span></label>
                                <Field
                                    validate={[required]}
                                    name="vehicleModelInfo"
                                    component={renderSelectField}
                                    options={isVehicleModelList}
                                    placeholder="Select Model"
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Type <span className='text-danger'>*</span></label>
                                <Field
                                    validate={[required]}
                                    name="vehicleTypeInfo"
                                    component={renderSelectField}
                                    options={isVehicleTypeList}
                                    placeholder="Select Type"
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Mfg. Year <span className='text-danger'>*</span></label>
                                <Field
                                    name="yearOfManufacture"
                                    component={renderSelectField}
                                    options={years}
                                    validate={required}
                                    placeholder="Select Year"
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Capacity (kg) <span className='text-danger'>*</span></label>
                                <Field
                                    name="loadCapacity"
                                    component={renderCompactField}
                                    validate={required}
                                    placeholder="Vehicle Capacity"
                                    icon={ScaleIcon}
                                    type="text"
                                />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Identification & Status Section */}
            <Card className="border-0 shadow-sm mb-2">
                <CardBody className="p-2">
                    <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                        <BadgeIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Identification & Status</h6>
                    </div>
                    <Row className="g-2">
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Unique ID <span className='text-danger'>*</span></label>
                                <Field
                                    validate={[required]}
                                    component={renderCompactField}
                                    name="vehicleUniqueId"
                                    type="text"
                                    placeholder="Vehicle Unique ID"
                                    icon={BadgeIcon}
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Plate No. <span className='text-danger'>*</span></label>
                                <Field
                                    validate={required}
                                    component={renderCompactField}
                                    name="plateNo"
                                    type="text"
                                    placeholder="Plate No."
                                    icon={DriveEtaIcon}
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Registration Expiry <span className='text-danger'>*</span></label>
                                <div className="compact-datepicker">
                                    <DatePickerOnly setDate={setExpDate} name="vehicleRegistrationExpiryDate" value={vehicleRegistrationExpiryDate} />
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-1 d-block" style={{ fontSize: '0.7rem' }}>OPERATIONAL STATUS</label>
                                <Field
                                    name="status"
                                    component={renderToggleButtonField}
                                    defaultChecked={status}
                                />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Action Bar */}
            <div className="d-flex justify-content-end pt-2 mt-2 border-top">
                <Button
                    color="primary"
                    type="submit"
                    size="sm"
                    className="px-4 py-1 rounded-pill shadow-sm d-flex align-items-center"
                    style={{ background: 'linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)', border: 'none', color: '#000', fontWeight: 'bold', fontSize: '0.85rem' }}
                >
                    <SaveIcon style={{ fontSize: '1rem' }} className="me-1" />
                    {vehicleData ? 'Update' : 'Save'}
                </Button>
            </div>
        </form>
    );
};


VehicleAddOrUpdate.propTypes = {
    //VehicleAddOrUpdate: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};


const mapStateToProps = (state, data) => {
    if (data && data.vehicleData) {
        return {
            initialValues: {
                plateNo: data.vehicleData.plateNo,
                vehicleUniqueId: data.vehicleData.vehicleUniqueId,
                vehicleMakersInfo: { "label": data.vehicleData.makerName, "value": data.vehicleData.vehicleMakerId },
                vehicleTypeInfo: { "label": data.vehicleData.vehicleType, "value": data.vehicleData.vehicleTypeId },
                vehicleModelInfo: { "label": data.vehicleData.modelName, "value": data.vehicleData.vehicleModelId },
                countryInfo: { "label": data.vehicleData?.countryName, "value": data.vehicleData?.countryId },
                stateInfo: { "label": data.vehicleData?.stateName, "value": data.vehicleData?.stateId },
                vehicleId: data.vehicleData.vehicleId,
                yearOfManufacture: { "label": data.vehicleData.yearOfManufacture, "value": data.vehicleData.yearOfManufacture },
                hubInfo: { "label": data.vehicleData.hubName, "value": data.vehicleData.hubId },
                loadCapacity: data.vehicleData?.loadCapacity,
                vehicleRegistrationExpiryDate: data?.vehicleData?.vehicleRegistrationExpiryDate,
                status: data.vehicleData?.status
            }
        }

    }
    return {};
}

export default connect(mapStateToProps)(reduxForm({ form: 'VehicleAddOrUpdateForm', enableReinitialize: true })(VehicleAddOrUpdate));